export const SUCCESS_GET_WBS = "SUCCESS_GET_WBS";
export const ERROR_GET_WBS = "ERROR_GET_WBS";
export const LOADING_WBS = "LOADING_WBS";
export const CLEARREPORT = "CLEARREPORT";
